/**
 * Whiteboard module constants
 * Filter options, sort options, and default values
 */

// Sort options for Listings tab
export const LISTING_SORT_OPTIONS = [
  { value: "new-old", label: "Newest" },
  { value: "old-new", label: "Oldest" },
  { value: "go-live-date", label: "Go Live Date" },
  { value: "p-low-high", label: "Price: Low to High" },
  { value: "p-high-low", label: "Price: High to Low" },
  { value: "recently-changed", label: "Recently Changed" },
];

// Sort options for Open Houses tab
export const OPEN_HOUSE_SORT_OPTIONS = [
  { value: "upcoming", label: "Upcoming" },
  { value: "need-host", label: "Needs Host" },
];

// Price filter options
export const PRICE_OPTIONS = [
  { value: null, label: "Any" },
  { value: 50000, label: "$50,000" },
  { value: 100000, label: "$100,000" },
  { value: 150000, label: "$150,000" },
  { value: 200000, label: "$200,000" },
  { value: 250000, label: "$250,000" },
  { value: 300000, label: "$300,000" },
  { value: 400000, label: "$400,000" },
  { value: 500000, label: "$500,000" },
  { value: 750000, label: "$750,000" },
  { value: 1000000, label: "$1,000,000" },
  { value: 1500000, label: "$1,500,000" },
  { value: 2000000, label: "$2,000,000" },
  { value: 3000000, label: "$3,000,000" },
  { value: 5000000, label: "$5,000,000" },
  { value: 10000000, label: "$10,000,000" },
];

// Beds filter options
export const BEDS_OPTIONS = [
  { value: 0, label: "Any" },
  { value: 1, label: "1+" },
  { value: 2, label: "2+" },
  { value: 3, label: "3+" },
  { value: 4, label: "4+" },
  { value: 5, label: "5+" },
  { value: 6, label: "6+" },
];

// Baths filter options
export const BATHS_OPTIONS = [
  { value: 0, label: "Any" },
  { value: 1, label: "1+" },
  { value: 1.5, label: "1.5+" },
  { value: 2, label: "2+" },
  { value: 2.5, label: "2.5+" },
  { value: 3, label: "3+" },
  { value: 3.5, label: "3.5+" },
  { value: 4, label: "4+" },
];

// Square feet filter options
export const SQFT_OPTIONS = [
  { value: null, label: "Any" },
  { value: 500, label: "500" },
  { value: 750, label: "750" },
  { value: 1000, label: "1,000" },
  { value: 1250, label: "1,250" },
  { value: 1500, label: "1,500" },
  { value: 2000, label: "2,000" },
  { value: 2500, label: "2,500" },
  { value: 3000, label: "3,000" },
  { value: 4000, label: "4,000" },
  { value: 5000, label: "5,000" },
];

// Lot size filter options (in acres)
export const LOT_SIZE_OPTIONS = [
  { value: null, label: "Any" },
  { value: 0.25, label: "0.25 acres" },
  { value: 0.5, label: "0.5 acres" },
  { value: 1, label: "1 acre" },
  { value: 2, label: "2 acres" },
  { value: 5, label: "5 acres" },
  { value: 10, label: "10 acres" },
  { value: 20, label: "20 acres" },
];

// Year built filter options (generated dynamically)
export const generateYearOptions = () => {
  const currentYear = new Date().getFullYear();
  const options = [{ value: null, label: "Any" }];
  for (let year = currentYear; year >= 1900; year -= 5) {
    options.push({ value: year, label: String(year) });
  }
  return options;
};

export const YEAR_OPTIONS = generateYearOptions();

// Default filter values
export const DEFAULT_FILTERS = {
  minPrice: null,
  maxPrice: null,
  beds: 0,
  baths: 0,
  minsqFt: null,
  maxsqFt: null,
  minLotSize: null,
  maxLotSize: null,
  minYearBuilt: null,
  maxYearBuilt: null,
};

// Check if filters are active (not default)
export const hasActiveFilters = (filters) => {
  return Object.entries(filters).some(([key, value]) => {
    if (key === "beds" || key === "baths") return value > 0;
    return value !== null;
  });
};
